export const MachineTypes = [
    { id: 1, type: 1, value: ["SinglerRack", "Rejilla individual"], setValue: "singleRack" },
    { id: 2, type: 2, value: ["Double rack", "Rejilla doble"], setValue: "doubleRack" },
    { id: 3, type: 3, value: ["Conveyor", "Tren de lavado"], setValue: "conveyor" },
    { id: 4, type: 4, value: ["Under Counter", "Bajo el mostrador"], setValue: "underCounter" },
    { id: 5, type: 0, value: ["I'm not sure", "No estoy seguro"], setValue: "notSure" },
]
export const machineModels = [
    {
        type: 1, values: [
            { id: 1, type: 1, setValue: "eht", value: ["EHT Dishmachine", "Lavavajillas EHT"] },
            { id: 2, type: 1, setValue: "elt", value: ["ELT Dishmachine", "Lavavajillas ELT"] },
            { id: 3, type: 1, setValue: "es-2000", value: ["ES-2000 Dishmachine", "Lavavajillas ES-2000"] },
            { id: 4, type: 1, setValue: "es-2000hh", value: ["ES-2000HT Dishmachine", "Lavavajillas ES-2000HT"] },
            { id: 5, type: 1, setValue: "es-2000ht-vapor-vent", value: ["ES-2000HT Vapor Vent Dishmachine", "Lavavajillas con ventilación de vapor ES-2000HT"] },
            { id: 6, type: 1, setValue: "es-2000hh", value: ["ES-2000HH Dishmachine", "Lavavajillas ES-2000HH"] },
            { id: 7, type: 1, setValue: "xl-2000", value: ["XL-2000 Dishmachine", "Lavavajillas XL-2000"] },
            { id: 8, type: 1, setValue: "smartpower-ht", value: ["SMARTPOWER(TM) TSC Single Rack Dishmachine", "Lavavajillas SMARTPOWER(TM) TSC de rejilla individual"] },
            { id: 9, type: 1, setValue: "xl-ht", value: ["XL-HT Dishmachine", "Lavavajillas XL-HT"] },
            { id: 10, type: 1, setValue: "xl-ht-vv", value: ["XL-HT VV Dishmachine", "Lavavajillas XL-HT VV"] },
            { id: 11, type: 1, setValue: "notSure", value: ["I’m not sure", "No estoy seguro"] },
        ]
    },
    {
        type: 2, values:
            [
                { id: 1, type: 2, setValue: "es-4000", value: ["ES 4000 Dishmachine", "Lavavajillas ES 4000"] },
                { id: 2, type: 2, setValue: "smartpower-ht-double", value: ["SMARTPOWER(TM) TSC Double Rack Dishmachine", "Lavavajillas SMARTPOWER(TM) TSC de doble rejilla"] },
                { id: 3, type: 2, setValue: "notSure", value: ["I’m not sure", "No estoy seguro"] },
            ]
    },
    {
        type: 3, values: [
            { id: 1, type: 3, setValue: "ec-lw", value: ["EC-LW Conveyor Dishmachine", "Lavavajillas con transportador EC-LW"] },
            { id: 2, type: 3, setValue: "notSure", value: ["I’m not sure", "No estoy seguro"] },
        ]
    },
    {
        type: 4, values: [
            { id: 1, type: 4, setValue: "df-rotary", value: ["DF Rotary Dishmachine", "Lavavajillas Giratorio DF"] },
            { id: 2, type: 4, setValue: "e-uht", value: ["E-UHT Dishmachine", "Lavavajillas E-UHT"] },
            { id: 3, type: 4, setValue: "e-ult", value: ["E-ULT Dishmachine", "Lavavajillas E-ULT"] },
            { id: 4, type: 4, setValue: "omega-5", value: ["Omega 5 Dishmachine", "Lavavajillas Omega 5"] },
            { id: 5, type: 4, setValue: "notSure", value: ["I’m not sure", "No estoy seguro"] },
        ]
    },
    {
        type: 0, values: [
            { id: 1, type: 1, setValue: "eht", value: ["EHT Dishmachine", "Lavavajillas EHT"] },
            { id: 2, type: 1, setValue: "elt", value: ["ELT Dishmachine", "Lavavajillas ELT"] },
            { id: 3, type: 1, setValue: "es-2000", value: ["ES-2000 Dishmachine", "Lavavajillas ES-2000"] },
            { id: 4, type: 1, setValue: "es-2000hh", value: ["ES-2000HT Dishmachine", "Lavavajillas ES-2000HT"] },
            { id: 5, type: 1, setValue: "es-2000ht-vapor-vent", value: ["ES-2000HT Vapor Vent Dishmachine", "Lavavajillas con ventilación de vapor ES-2000HT"] },
            { id: 6, type: 1, setValue: "es-2000hh", value: ["ES-2000HH Dishmachine", "Lavavajillas ES-2000HH"] },
            { id: 7, type: 1, setValue: "xl-2000", value: ["XL-2000 Dishmachine", "Lavavajillas XL-2000"] },
            { id: 8, type: 1, setValue: "smartpower-ht", value: ["SMARTPOWER(TM) TSC Single Rack Dishmachine", "Lavavajillas SMARTPOWER(TM) TSC de rejilla individual"] },
            { id: 9, type: 1, setValue: "xl-ht", value: ["XL-HT Dishmachine", "Lavavajillas XL-HT"] },
            { id: 10, type: 1, setValue: "xl-ht-vv", value: ["XL-HT VV Dishmachine", "Lavavajillas XL-HT VV"] },
            { id: 11, type: 2, setValue: "es-4000", value: ["ES 4000 Dishmachine", "Lavavajillas ES 4000"] },
            { id: 12, type: 2, setValue: "smartpower-ht-double", value: ["SMARTPOWER(TM) TSC Double Rack Dishmachine", "Lavavajillas SMARTPOWER(TM) TSC de doble rejilla"] },
            { id: 13, type: 3, setValue: "ec-lw", value: ["EC-LW Conveyor Dishmachine", "Lavavajillas con transportador EC-LW"] },
            { id: 14, type: 4, setValue: "df-rotary", value: ["DF Rotary Dishmachine", "Lavavajillas Giratorio DF"] },
            { id: 15, type: 4, setValue: "e-uht", value: ["E-UHT Dishmachine", "Lavavajillas E-UHT"] },
            { id: 16, type: 4, setValue: "e-ult", value: ["E-ULT Dishmachine", "Lavavajillas E-ULT"] },
            { id: 17, type: 4, setValue: "omega-5", value: ["Omega 5 Dishmachine", "Lavavajillas Omega 5"] },
            { id: 18, type: 0, setValue: "notSure", value: ["I’m not sure", "No estoy seguro"] },
        ]
    }
]